import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
const audience = [{
  icon: '🏉',
  title: 'Jugadores estancados',
  desc: 'Amateurs y semiprofesionales que entrenan hace años pero siguen sin ver el progreso que esperaban.'
}, {
  icon: '🏟️',
  title: 'Jugás en club o selección provincial',
  desc: 'Con lo que tenés en tu club alcanza. Sin instalaciones de alto rendimiento ni cuerpo técnico costoso.'
}, {
  icon: '🆕',
  badge: 'NUEVO',
  title: 'Jugadores que quieren ser referentes',
  desc: 'Querés transmitir tu conocimiento y convertirte en referente dentro de tu equipo o club.'
}, {
  icon: '🎯',
  title: 'Buscás llegar a otro nivel',
  desc: 'Vas por la primera de tu club, el seleccionado provincial o simplemente ser el mejor jugador que podés ser.'
}];
export function Audience() {
  return <section className="py-14 md:py-24 bg-rugby-green-950 relative pattern-dots" data-id="element-19">
      <div className="container mx-auto px-4" data-id="element-20">
        <div className="max-w-5xl mx-auto" data-id="element-21">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-8 md:mb-16" data-id="element-22">
            <h2 className="text-3xl md:text-5xl font-display text-white mb-2 md:mb-4" data-id="element-23">
              ¿PARA QUIÉN ES?
            </h2>
            <p className="text-base md:text-xl text-rugby-gold-400 font-serif italic px-2" data-id="element-24">
              Diseñado para vos si querés llevar tu rugby al próximo nivel
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-8 md:mb-16" data-id="element-25">
            {audience.map((a, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} whileHover={{
            y: -3
          }} className="bg-rugby-green-900 border border-rugby-green-700 hover:border-rugby-gold-500/40 p-4 md:p-8 rounded-2xl relative overflow-hidden group transition-colors" data-id="element-26">
                <div className="absolute top-0 right-0 w-32 h-32 bg-rugby-gold-500/5 rounded-bl-full -mr-10 -mt-10 transition-transform group-hover:scale-110" data-id="element-27" />

                <div className="flex items-start justify-between mb-2 md:mb-4 relative z-10" data-id="element-28">
                  <span className="text-3xl md:text-4xl" data-id="element-29">{a.icon}</span>
                  {a.badge && <span className="bg-rugby-gold-500 text-rugby-green-950 text-[10px] md:text-xs font-bold px-2 py-1 rounded uppercase tracking-wider" data-id="element-30">
                      {a.badge}
                    </span>}
                </div>

                <h3 className="text-base md:text-xl font-bold text-white mb-1.5 md:mb-3 relative z-10" data-id="element-31">
                  {a.title}
                </h3>
                <p className="text-slate-300 text-sm md:text-base leading-relaxed relative z-10" data-id="element-32">
                  {a.desc}
                </p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-center flex flex-col items-center justify-center gap-2" data-id="element-33">
            <p className="text-sm md:text-base text-slate-400" data-id="element-34">
              ¿No estás seguro si es para vos?
            </p>
            <div className="flex items-center gap-2 text-rugby-gold-400 font-medium text-sm md:text-base" data-id="element-35">
              <ShieldCheck size={18} data-id="element-36" />
              <span data-id="element-37">Tenés 7 días de garantía →</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}